import React from 'react';
import { Link } from 'react-router-dom';

export default function SidebarItem({ icon, label, path, darkMode, isComingSoon = false, active, collapsed = false }) {
  const itemTitle = isComingSoon ? `${label} (Coming Soon)` : label;

  return (
    <Link
      to={!isComingSoon ? path : '#'}
      title={collapsed ? itemTitle : undefined}
      aria-label={collapsed ? itemTitle : undefined}
      className={`flex items-center ${collapsed ? 'justify-center' : 'justify-between'} p-2.5 rounded-xl transition-all relative ${
        isComingSoon ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
      } ${
        active
          ? 'bg-purple-600/10 text-purple-500 border border-purple-500/10'
          : `text-gray-500 ${darkMode ? 'hover:text-gray-300 hover:bg-gray-800/30' : 'hover:text-gray-900 hover:bg-gray-100'}`
      }`}
    >
      <div className={`flex min-w-0 items-center ${collapsed ? '' : 'gap-3'}`}>
        <span className="shrink-0">{icon}</span>
        <span className={`overflow-hidden whitespace-nowrap text-[13px] font-medium transition-[max-width,opacity] duration-200 ${collapsed ? 'max-w-0 opacity-0' : 'max-w-40 opacity-100'}`}>
          {label}
        </span>
      </div>
      
      {isComingSoon && (
        <span className={`text-[8px] font-black uppercase tracking-tighter px-1.5 py-0.5 rounded bg-cyan-500/15 text-cyan-600 border border-cyan-500/40 dark:text-cyan-400 animate-pulse ${collapsed ? 'hidden' : ''}`}>
          Coming Soon
        </span>
      )}
    </Link>
  );
}